module.exports = __webpack_public_path__ + "static/logo-3957c8135fe91ed538084c7c2f7db929.png";